/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebComponents {

    "use strict";


    export class AreaSelectionsDirectiveController {

        public static $inject: string[] = [
            '$injector', '$rootScope', '$scope', '$element', '$timeout'
        ];

        private activeBoxId: string;

        private SelectionBoxHelperService: any;

        private targetDomSelector: any;

        private onSelectionBoxCreated: any;
        private onSelectionBoxSizing: any;
        private onSelectionBoxMoved: any;

        private disableSelectionBoxMove: boolean;
        private eventScope: any;

        private unwatchInitialize: any;

        private allowedSelectionBoxCreationIds: any;

        private boxes: any[];

        public scopeTransferProperties: string[] = [
            'boxes', 'activeBoxId', 'targetDomSelector', 'onSelectionBoxCreated',
            'onSelectionBoxSizing', 'onSelectionBoxMoved', 'disableSelectionBoxMove',
            'eventScope'
        ];


        constructor(
            private $injector: any,
            private $rootScope: any,
            private $scope   : any,
            private $element : any,
            private $timeout : any
        ) {

            this.SelectionBoxHelperService = this.$injector.get('SelectionBoxHelperService');

            this.enable();
        }

        private enable ( ) : void {

            var that = this;

            if (this.unwatchInitialize) {
                return;
            }

            this.unwatchInitialize = this.$scope.$watch( ( ) => {
                return that.targetDomSelector;
            }, ( selector: any ) => {

                if (! selector) {
                    return;
                }

                that.$timeout( ( ) => {
                    angular.element(selector)
                    .on('mousedown', (e: JQueryEventObject, box: any) => {

                            // Name key needs to be provided, or box can't be tracked.
                            //
                            if (that.activeBoxId === undefined) {
                                return;
                            }

                            // This case is a user event.
                            //
                            if (box === undefined) {

                                // An assertion of null in this property means there's no restriction on user
                                // creation of selectionBoxes.  Otherwise, only boxes with ids in the array
                                // are allowed to be created by user event.
                                //
                                var idsFunction = (that.allowedSelectionBoxCreationIds || angular.noop);
                                if ( idsFunction() !== null
                                     && (idsFunction() || [ ]).indexOf(that.activeBoxId) === -1
                                   ) {
                                    return;
                                }
                                box = (<any>that.boxes)[that.activeBoxId];
                            }
                            // This case means a (pre-saved?) box has been supplied, and it just needs
                            // to be drawn whole as if user had done it.
                            //
                            else {
                                box.preDefined = true;
                            }

                            that.boxCreating (e, box);
                        });
                })
            });
        }

        // TODO: dynamic disable might be useful.  Generally, just deleting all the boxes is good enough.
        //
        private disable ( ) : void {

            if (! this.unwatchInitialize) {
                return;
            }

            angular.element(this.targetDomSelector).off('mousedown');
            this.unwatchInitialize();
            this.unwatchInitialize = undefined;
        }

        private boxCreating ( e: JQueryEventObject, box: any ) : void {

            var that = this;

            // Without any selectionBox identifier, we can neither create a new one nor modify an existing.
            //
            if (box.created) {

                // Box and its data already created in DOM.  Bail.
                //
                return;
            }

            // Created isolated scope so each box retains its own private data, so manually transfer
            // properties on the main scope for AS to the isolated scopes.
            //
            // Function methods can be called with a passed-in scope.
            //
            var isolatedScope = this.$rootScope.$new();
            this.scopeTransferProperties.forEach( ( prop: string ) => {
                if (typeof that.$scope.AS[prop] === 'function' && that.$scope.AS['eventScope']) {
                    isolatedScope[prop] = ( box: any ) => {
                        return that.$scope.AS[prop].call(that.$scope.AS['eventScope'], box);
                    }
                }
                else {
                    isolatedScope[prop] = that.$scope.AS[prop];
                }
            });
            isolatedScope.box = box;

            // Box element actually created, and inserted into the DOM.
            //
            var helper = this.$injector.get('SelectionBoxHelperService');
            var elem = helper.create('selectionBox', this.$element, isolatedScope);
            box.element = elem;

            // Save off pre-configured box properties for restoration later since they're
            // lost in the actual box creation.
            //
            var boxProperties : any = { };
            Object.keys(box).forEach( ( key: string ) => {
                boxProperties[key] = box[key];
            });

            // Needing $apply for the box creation.
            //
            this.$scope.$apply( ( ) => {

                // Since createEvent is a property watched by the box directive, this causes all
                // the box properties such as beginning dimensions, to be set.
                //
                box.createEvent = e;

                // Allow for pre-configured content to be innerHTML the selection box's html.
                //
                if (box.content && box.content.template) {
                    that.$timeout( ( ) => {
                        box.content.element = helper.create(
                            box.content.template, elem, isolatedScope
                        );
                    });
                }
            });

            // Saved off from the original, passed in box properties will override what gets
            // calculated in the box watchers, i.e. the 'left' property.
            //
            Object.keys(boxProperties).forEach( ( key: string ) => {
                box[key] = boxProperties[key];
            });
        };
    }

    getDealerwareWebComponentsModule().controller('AreaSelectionsDirectiveController', AreaSelectionsDirectiveController);


    export class AreaSelectionsDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'AreaSelectionsDirectiveController';
        public controllerAs     : string    =   'AS';
        public bindToController : boolean   =   true;
        public scope            : Object    =   {

            boxes                           : '=',

            activeBoxId                     : '=?',
            targetDomSelector               : '@?',

            onSelectionBoxCreated           : '=?',
            onSelectionBoxSizing            : '=?',
            onSelectionBoxMoved             : '=?',

            // TODO: these.
            //
            /*
            onSelectionBoxCreating          : '=?',
            onSelectionBoxSized             : '=?',
            onSelectionBoxMoving            : '=?',
            onSelectionBoxResized           : '=?',
            onSelectionBoxResizing          : '=?',
            */

            disableSelectionBoxMove         : '=?',
            // TODO: this, and maybe its friends.
            //
            /*
            disableResize                   : '=?',
            */


            eventScope                      : '=?',

            doStyling                       : '&?',

            selectionTarget                 : '=',
            selectionTargetScopeInsertions  : '=?',

            allowedSelectionBoxCreationIds  : '&?'
        };

        public templateUrl      : string    =   '/components/area-selections/area-selections-directive.html';
    }

    getDealerwareWebComponentsModule().directive(
        'areaSelections',
        ( ) => new AreaSelectionsDirective()
    );


    interface ISelectionTargetScope extends ng.IScope {
        scopeInsertions: any;
    }

    export class SelectionTargetDirective implements ng.IDirective {

        public restrict         : string = 'E';
        public scope            : Object = {
            targetPath          : '=?target',
            scopeInsertions     : '=?'
        };

        public template         : string    =   '<div ng-include="targetPath"></div>';
        public static $inject   : string[]  =   [ ];

        public link : ng.IDirectiveLinkFn = (
            $scope: ISelectionTargetScope
        ) => {

            // The ng-include makes it own scope, so the scopeInsertions property is a way of getting
            // all manner of scope properties and methods down into the scope of the SelectionTarget.
            //
            if ($scope.scopeInsertions) {
                Object.keys($scope.scopeInsertions).forEach( ( scopeKey: string ) => {
                    $scope[scopeKey] = $scope.scopeInsertions[scopeKey];
                })
            }
        }
    }

    getDealerwareWebComponentsModule().directive(
        'selectionTarget',
        ( ) => new SelectionTargetDirective()
    );
}
